import { Fragment } from 'react';

import MealsSummary from './MealsSummary';
import AvailableMeals from './AvailableMeals';

const Meals = ({ activeCategory }) => {
  return (
    <Fragment>
      <MealsSummary />
      <AvailableMeals activeCategory={activeCategory} />
    </Fragment>
  );
};

export default Meals;
